import React from "react"

// components
import { Image } from "antd"

// configs
import config from "config"

// firebase
import { Functions } from "services/firebase"
import { httpsCallable } from "firebase/functions"

// utils
import { FallbackImage } from "utils/image"

const GoogleStaticImage = ({ route }) => {
  const [signature, setSignature] = React.useState()
  const [state, setState] = React.useState("idle")

  React.useEffect(() => {
    const asyncHandlers = async () => {
      try {
        setState("load-signature")

        const url = `https://maps.googleapis.com/maps/api/staticmap?scale=2&markers=size:small|color:0x${config.color.replace(
          "#",
          ""
        )}|label:x|${config.location.lat},${
          config.location.lng
        }&markers=size:mid|color:red|label:|${route.destination.lat},${
          route.destination.lng
        }&center=${route.center.lat},${route.center.lng}&zoom=${
          route.zoom
        }&style=feature:poi|visibility:off&size=400x400&map_id=bbb43cf045c17a515c124f60&path=color:0x0000ffff|weight:5|enc:${
          route.polyline
        }&key=${process.env.NEXT_PUBLIC__GOOGLE_MAPS_STATIC_API_KEY}`

        const {
          data: { signature },
        } = await httpsCallable(Functions, "getSig")({ url })

        setSignature(signature)
        setState("idle")
      } catch (e) {
        setState("error")
      }
    }

    asyncHandlers()
  }, [route])

  return (
    <Image
      width="100%"
      height="auto"
      src={signature}
      alt="route"
      preview={false}
      style={{
        borderRadius: "8px",
        objectFit: "cover",
      }}
      fallback={FallbackImage}
    />
  )
}

export default GoogleStaticImage
